export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/snackbarSuccess.bccd41b0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};